import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";

const initialState = {
    status: 'idle',
    searchlist: [],
    searchText:'',
    error: '',
    startidx: 0,
    endidx: 25,
    searchValues: {}, // Store API request values
    morebtn: true,
    currentRequestId: null,
}

export const searchResult = createAsyncThunk(
    'search/searchResult',
    async (values) => {
        const res = await axios.post(`${process.env.REACT_APP_BASE_URL}/api/allproducts`, values)
        return res.data.data
    }
)

export const loadMoreRecords = createAsyncThunk(
    'search/loadMoreRecords',
    async (values) => {
        const res = await axios.post(`${process.env.REACT_APP_BASE_URL}/api/dbproducts`, values)
        //console.log(res.data)
        return res.data.data
    }
)

export const searchSlice = createSlice({
    name:'search',
    initialState,
    reducers: {

    },
    extraReducers: (builder) => {
        builder
        .addCase(searchResult.pending, (state) => {
            state.status = 'loading'
            state.error = ''
        })
        .addCase(searchResult.fulfilled, (state, action) => {
            const page = action.meta.arg.page ?? 1;
            const pageSize = action.meta.arg.pageSize ?? 25;
            const newProducts = action.payload.products ?? [];
            if (page === 1) {
                state.searchlist = action.payload;
            } else {
                state.searchlist = {
                    ...action.payload,
                    products: [
                        ...(state.searchlist?.products ?? []),
                        ...newProducts,
                    ],
                };
            }
            state.searchValues = action.meta.arg;
            state.status = "true";
            state.hasMore = newProducts.length === pageSize;
            if(action.payload.total === 0) {
                toast.info("No results found", { position:"bottom-center", toastId: "no-results",})
            }
        })
        .addCase(searchResult.rejected, (state, action) => {
            if (state.currentRequestId !== action.meta.requestId) return;

            state.status = "false";
            state.error = action.error.message || "Something went wrong";
            state.currentRequestId = null;
        })
        .addCase(loadMoreRecords.pending, (state) => {
            state.status = 'loading'
            state.error = ''
        })
        .addCase(loadMoreRecords.fulfilled, (state, action) => {
            state.status = "true"
            state.error = ''
            state.startidx += 25
            state.endidx += 25
            state.morebtn = true
            state.searchlist = [...state.searchlist, ...action.payload];
            
            if (action.payload.length < 25) {
                state.morebtn = false
            }
        })
        .addCase(loadMoreRecords.rejected, (state, action) => {
            state.status = "false"
            state.searchlist = []
            state.error = action.error.message
        })
    }
})

export const searchresultlist = (state) => state.search.searchlist
export const searchValuesSelector = (state) => state.search.searchValues;
export default searchSlice.reducer